import { useState } from 'react';
import { useSnackbar } from 'notistack';

import { importProductData } from '../../../../../crud/offer.crud';
import { useFormatMessage } from '../../../../../hooks';
import { getResponseMessage } from '../../../../../utils/utils';

export function useImportProductData() {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingUpload, setLoading] = useState(false);
  const [successUpload, setSuccess] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const fm = useFormatMessage();

  const upload = async (data: { file: FormData }) => {
    setLoading(true);
    importProductData(data)
      .then(res => {
        if (res.data?.data?.errors && res.data.data.errors.length > 0) {
          setErrors(res.data.data.errors);
        } else {
          setErrors([]);
          setSuccess(true);
        }
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 200);
      });
  };

  const uploadFiles = async (files: File[]) => {
    setLoading(true);
    const aggregatedErrors: string[] = [];
    for (const f of files) {
      const formData = new FormData();
      formData.append('file', f);
      try {
        // eslint-disable-next-line no-await-in-loop
        const res = await importProductData({ file: formData });
        if (res.data?.data?.errors && res.data.data.errors.length > 0) {
          aggregatedErrors.push(...res.data.data.errors);
        }
      } catch (e: any) {
        aggregatedErrors.push(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      }
    }
    if (aggregatedErrors.length > 0) {
      setErrors(aggregatedErrors);
      setSuccess(false);
    } else {
      setErrors([]);
      setSuccess(true);
    }
    setLoading(false);
    setTimeout(() => {
      setSuccess(false);
    }, 200);
  };

  return { upload, uploadFiles, loadingUpload, successUpload, errors };
}
